import { useAppStore } from '../../stores/appStore'
import { OauthOption } from '../../types/auth/oauthOption'

const salesforceIssuer = import.meta.env.VITE_SALESFORCE_DOMAIN
const salesforceClientId = import.meta.env.VITE_SALESFORCE_CLIENT_ID
const clientName = import.meta.env.VITE_AIDA_LIBRARY_CLIENT_NAME
const salesforceRedirectUri = import.meta.env.VITE_SALESFORCE_REDIRECT_URI || window.location.origin

const isSalesforceEnvConfigured = Boolean(salesforceIssuer && salesforceClientId)

export function isSalesforceConfigured(): boolean {
  const appStore = useAppStore()
  const hasSalesforceOption = appStore.configuration?.login?.oauthOptions?.includes(
    OauthOption.Salesforce
  )
  return Boolean(isSalesforceEnvConfigured && hasSalesforceOption)
}

export async function signInWithSalesforceAsync(): Promise<void> {
  const appStore = useAppStore()
  const hasSalesforceOption = appStore.configuration?.login?.oauthOptions?.includes(
    OauthOption.Salesforce
  )

  if (!isSalesforceEnvConfigured || !hasSalesforceOption) {
    console.error('Salesforce is not configured.')
    return
  }

  const authorizeUrl = new URL('/services/oauth2/authorize', salesforceIssuer)
  authorizeUrl.searchParams.set('response_type', 'code') // <- implicit (no PKCE)
  authorizeUrl.searchParams.set('client_id', salesforceClientId)
  authorizeUrl.searchParams.set('redirect_uri', salesforceRedirectUri)
  authorizeUrl.searchParams.set('scope', ['openid', 'profile', 'email', 'refresh_token'].join(' '))
  authorizeUrl.searchParams.set('state', JSON.stringify({ client_name: clientName }))

  window.location.assign(authorizeUrl.toString())
}
